import { render, staticRenderFns } from "./results.vue?vue&type=template&id=08d8efb2&scoped=true"
import script from "./results.vue?vue&type=script&lang=js"
export * from "./results.vue?vue&type=script&lang=js"
import style0 from "./results.vue?vue&type=style&index=0&id=08d8efb2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d8efb2",
  null
  
)

export default component.exports